import styles from './TreatmentsByTimeGraph.module.scss'
import { ResponsiveLine } from "@nivo/line";
import moment from 'moment';

const TreatmentsByTimeGraph = ({ tick, data }) => {
    return (<div className='reportChart' style={ { width: '100%', height: 300, maxHeight: 340 } }>
        <h4>Treatments by Time</h4>
        {data.length > 0 ? <ResponsiveLine
            data={ [
                { id: 'date', data: data }
            ] }
            tooltip={ point => {
                const date = new Date(point.point.data.x);
                const sessions = point.point.data.y;
                const formattedDate = moment(date).format(tick === 'day' ? "MMM DD" : "MMM Y");
                return <div style={ {
                    background: '#fff',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                } }>{ formattedDate } - { sessions } Treatments</div>;
            } }
            margin={ { top: 35, right: 20, bottom: 65, left: 20 } }
            indexBy="date"
            pointColor={ [
                '#5c9ceb',
            ] }
            lineWidth={ 3 }
            pointBorderColor={ { from: 'serieColor' } }
            enableGridX={ false }
            enableGridY={ false }
            colors={ [
                '#93d5ed',
            ] }
            curve="monotoneX"
            useMesh={ true }
            enablePointLabel={ true }
            xScale={ {
                type: 'time',
                format: "%Y-%m-%d",
                precision: 'day',
                useUTC: false
            } }
            axisBottom={ {
                tickValues: tick === 'day' ? 'every 3 days' : (data.length > 6 ? 'every 2 months' : 'every 1 month'),
                format: tick === 'day' ? "%b %d" : "%b %Y",
                tickRotation: 0,
                legend: '',
                legendOffset: 40,
                legendPosition: 'middle',
            } }
            axisLeft={ false }
            enableArea={ true }
        /> : <div className='noData'>No data available</div>}
    </div>)
}


export default TreatmentsByTimeGraph;